import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Hero from '../components/Hero';
import BentoGallery from '../components/BentoGallery';
import HealofyGallery from '../components/HealofyGallery';
import { ArrowUpRight } from 'lucide-react';

const Home = () => {
  const [data, setData] = useState({
    profile: null,
    projects: [],
    experience: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
        
        // Use Promise.allSettled to handle potential API failures gracefully
        const results = await Promise.allSettled([
          axios.get(`${backendUrl}/api/profile`),
          axios.get(`${backendUrl}/api/projects`),
          axios.get(`${backendUrl}/api/experience`)
        ]);

        const profile = results[0].status === 'fulfilled' ? results[0].value.data : null;
        const projects = results[1].status === 'fulfilled' ? results[1].value.data : [];
        const experience = results[2].status === 'fulfilled' ? results[2].value.data : [];

        setData({ profile, projects, experience });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-pastel-bg flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="bg-pastel-bg min-h-screen text-neutral-900 font-sans selection:bg-accent/20">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-pastel-bg/80 backdrop-blur-md border-b border-neutral-200/50">
        <div className="container mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_design-clarity-3/artifacts/z6pbzgda_sanket.daware.png" 
              alt="Sanket Daware" 
              className="h-5 w-auto object-contain" 
            />
          </div>

          <div className="flex gap-8 text-sm font-medium text-neutral-500">
            {/* 
            <a href="/" className="hover:text-neutral-900 transition-colors">Home</a>
            <a href="#about" className="hover:text-neutral-900 transition-colors">About</a>
            */}
            <a 
              href="https://www.linkedin.com/in/sanket-daware/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-neutral-900 transition-colors"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </nav>

      <main className="pt-10">
        <Hero profile={data.profile} />
        <BentoGallery />
        <HealofyGallery />
      </main>

      {/* Footer */}
      <footer className="py-20 border-t border-dashed border-neutral-300 mt-20">
        <div className="container mx-auto px-6 md:px-12">
            <div className="max-w-2xl">
                <h2 className="text-3xl font-medium mb-8">Want to get in touch? I'd love to connect with you!</h2>
                <div className="flex flex-col gap-4 items-start">
                    <a href={`mailto:${data.profile?.contact?.email}`} className="text-neutral-500 hover:text-accent transition-colors flex items-center gap-2">
                        Email <ArrowUpRight className="w-4 h-4" />
                    </a>
                    <a href="https://www.linkedin.com/in/sanket-daware/" target="_blank" rel="noopener noreferrer" className="text-neutral-500 hover:text-accent transition-colors flex items-center gap-2">
                        LinkedIn <ArrowUpRight className="w-4 h-4" />
                    </a>
                </div>
            </div>
            
            <div className="mt-20 text-gray-400 text-sm">
                © {new Date().getFullYear()} Sanket Daware.
            </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
